import Vue from '../../../../../assets/vendor/vue/dist/vue.min';
import Loader from '../partials/loader';
import DateSlider from '../partials/date-slider';

if(document.querySelector('[data-tv-guide]') ) {
    new Vue({
        el: '[data-tv-guide]',
        data: {
            loader: null,
            slider: null,
            programs: []
        },
        methods: {
            async getPrograms() {
                this.loader.loading(true);

                let activeDate = this.slider.getActiveDate();

                let result = await this.update(activeDate);
                this.programs = result.data;

                this.loader.loading(false);
            },
            async update(date) {
                const request = await fetch(
                        placeholders.baseUri
                                ? placeholders.baseUri + '/ajax/type/42?date=' + date
                                : 'ajax/type/42?date=' + date,
                        {
                            method: 'get',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                        }
                );
                const result = await request.json();
                return result;
            }
        },
        mounted () {
            this.loader = (new Loader(document.querySelector('[data-loader]')));
            this.slider = (new DateSlider(this.$refs.slider));
            this.slider.init();

            this.slider.slider.on('slideChange', this.getPrograms);

            this.getPrograms();

        }
    });
}